<div class="blog-card-container" (click)="readArticle()">
    <div class="blog-card">
        <div class="blog-image-col">
            <img [src]="blog.blogMainImage || './assets/images/blog-default.png'" [alt]="blog.title" class="blog-image" (error)="setDefaultImage($event)">
        </div>

        <div class="blog-content-col">
            <h3 class="blog-title">{{ blog.title }}</h3>
            <p class="blog-description">
                {{ blog.excerpt | slice:0:200 }}{{ blog.excerpt.length > 200 ? '...' : '' }}
            </p>

            <div class="blog-footer">
                <div class="creation-date">
                    {{ blog.createdAt }}
                </div>
                <a (click)="readArticle()" class="view-all-link d-flex align-items-center gap-2">
                    <img src="./assets/images/icons/file_white.png" alt="file icon" class="file-icon">
                    <span>Lire la suite</span>
                    <img src="./assets/images/icons/link_arrow.png" alt="arrow icon" class="arrow-icon">
                </a>
            </div>
        </div>
    </div>
</div>